import * as React from 'react'

const SvgArrowSmallUpOutlined = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 25 25"
    width="1em"
    height="1em"
    {...props}
  >
    <path
      fill="#60636B"
      fillRule="evenodd"
      d="M19.5947 11.9146C19.8876 12.2075 20.3624 12.2075 20.6553 11.9146C20.9482 11.6217 20.9482 11.1468 20.6553 10.8539L13.6553 3.85395C13.3624 3.56105 12.8876 3.56105 12.5947 3.85395L5.59467 10.8539C5.30178 11.1468 5.30178 11.6217 5.59467 11.9146C5.88756 12.2075 6.36244 12.2075 6.65533 11.9146L12.2043 6.36565C12.2673 6.30265 12.375 6.34727 12.375 6.43636L12.375 20.8843C12.375 21.2985 12.7108 21.6343 13.125 21.6343C13.5392 21.6343 13.875 21.2985 13.875 20.8843L13.875 6.43636C13.875 6.34727 13.9827 6.30265 14.0457 6.36565L19.5947 11.9146Z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgArrowSmallUpOutlined
